// extracted by mini-css-extract-plugin
export default {"title":"TileDetails_title__q2EQL","detail":"TileDetails_detail__KZPV1","ellipsis":"TileDetails_ellipsis__Sq7Eg"};